__turbopack_context__.v({
  "trigger": "C4TJyq_trigger",
});
